import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c4cb62a&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=4c4cb62a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cb62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4cb62a')) {
      api.createRecord('4c4cb62a', component.options)
    } else {
      api.reload('4c4cb62a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c4cb62a&scoped=true&", function () {
      api.rerender('4c4cb62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/list/index.vue"
export default component.exports